import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentUploadService } from '../../../common-services/document-upload.service'
import * as Enums from '../../../utils/enums';
import { Utility } from '../../../utils/utility';
import * as saveAs from 'file-saver';
import { ToastrService } from 'ngx-toastr'; 
import { TranslateService } from '@ngx-translate/core';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
@Component({
  selector: 'app-view-uploaded-document',
  templateUrl: './view-uploaded-document.component.html',
  styleUrls: ['./view-uploaded-document.component.css']
})
export class ViewUploadedDocumentComponent {
  expandedDemandDoc: boolean = false;
  documentList: any[] = [];
  imageToShow: string = '/assets/images/loading.svg';
  imageToOpen: string;
  documentId: number;
  AppointmentId: number;
  AppointmentFileName: string;
  documentComment: string;
  documentSource: string = "";
  documentSourceId: number = 0;
  index: number = 0;
  @Input() viewDemandDocument: any = {};
    @Input() apiBaseUrl: string = "";
    @Input() requestApplication: number;
  imgSources = []
  constructor(
    public activeModal: NgbActiveModal,
    private readonly spinner: NgxSpinnerService,
    private readonly documentUploadService: DocumentUploadService,
    private readonly toastr: ToastrService, 
    private readonly translate: TranslateService,
    private readonly appointmentService: AppointmentService,
    public editAppointmentService: EditAppointmentService
  ) { }

  OnClose() {
    this.activeModal.close({ success: true });
  }
  OnDemandExpand() {
    this.expandedDemandDoc = !this.expandedDemandDoc;
    if (this.expandedDemandDoc) {
      this.GetDemandWiseDocuments();
    }
  }
  async GetDemandWiseDocuments() {
    this.spinner.show();
    await this.documentUploadService.GetDemandWiseDocuments(`${this.apiBaseUrl}/Get`, this.viewDemandDocument?.demandId).then((response) => {
      this.spinner.hide();
      this.documentList = response.responseObject;
      if (this.documentList?.length > 0) {
        let obj = this.documentList[0]
        this.GetImageToShow(obj?.fileType, obj?.documentUrl)
        this.imageToOpen = obj?.documentUrl;
        this.AppointmentId = obj?.appointmentId;
        this.documentId = obj?.documentId;
        this.AppointmentFileName = obj?.fileName;
        this.documentComment = obj?.comment;
        this.documentSource = obj?.source;
        this.documentSourceId = obj?.applicationId;
      }
    }, _error => {
      this.spinner.hide()
    });
  }
  async ViewFile(url: string) {
    const exists = this.imgSources.find(x=>x.name == url);
    if (exists) {
      this.imageToShow = exists.base64;
    }
    else{
      this.imageToShow = '/assets/images/loading.svg';
      await this.documentUploadService.GetDemandViewFile(`${this.apiBaseUrl}/View`, url).then((res) => {
        if (res) {
          this.imageToShow = res;
          this.imgSources.push({ name: url, base64: res });
        }
        else{
          this.imageToShow = "assets/no-image-icon.png";
        }
      }, (_err)=>{
        this.imageToShow = "assets/no-image-icon.png";
      });
    }    
  }

  async deleteSingleDocument(AppointmentFileName: string, AppointmentId: number, documentId: number){
    let requestModel={
      documentId: documentId,
      documentName: AppointmentFileName,
      documentDemandId: null,
      appointmentId: AppointmentId 
    }
    
    let URL = this.apiBaseUrl;
    this.spinner.show(); 
    await this.documentUploadService.DeleteDocument(`${URL}/Delete`, requestModel).then(async (res) => { 
      if (res) {
        let msg = this.translate.instant("lblDocumentDeletedSuccessfully");
        this.toastr.success(msg);
        if(this.requestApplication == 1){
          await this.appointmentService.GetDocumentCount(AppointmentId).then((res) => {
            if (res?.responseObject?.length > 0) {
              this.editAppointmentService.DemandWiseDocumentCountList = [...res.responseObject];
            }
          });
        }
        this.GetDemandWiseDocuments();
        if (this.documentList.length>=2){
          this.next();
        }
        if (this.documentList.length<=1){
          this.OnClose();
        }
      }
      else{
        let errMsg = this.translate.instant("lblDocumentNotDeleted");
        this.toastr.error(errMsg)
      } 
    });
    this.spinner.hide();
  }

  GetImageToShow(type: string, documentUrl: string) {
    switch (type) {
      case Enums.MimeType.PDF: {
        this.imageToShow = "/assets/PDF_icon.png";
        break;
      }
      case Enums.MimeType.PNG:
      case Enums.MimeType.JPG:
      case Enums.MimeType.JPEG:
      case Enums.MimeType.GIF:
      case Enums.MimeType.SVG: {
        this.ViewFile(documentUrl);
        break;
      }
      case Enums.MimeType.MP4:
      case Enums.MimeType.QUICKTIME:
        {
          this.imageToShow = "assets/video.png";
          break;
        }
      default: {
        this.imageToShow = "assets/no-image-icon.png";
        break;
      }
    }
  }

  Previous() {
    this.index = this.index <= 0 ? this.documentList.length - 1 : this.index - 1;
    let obj = this.documentList[this.index];
    this.imageToOpen = obj?.documentUrl;
    this.AppointmentId = obj?.appointmentId;
    this.documentId = obj?.documentId;
    this.AppointmentFileName = obj?.fileName;
    this.documentComment = obj?.comment;
    this.documentSource = obj?.source;
    this.documentSourceId = obj?.applicationId;
    this.GetImageToShow(obj?.fileType, obj?.documentUrl)
  }
  next() {
    this.index = this.index >= this.documentList.length - 1 ? 0 : this.index + 1;
    let obj = this.documentList[this.index];
    this.imageToOpen = obj?.documentUrl;
    this.AppointmentId = obj?.appointmentId;
    this.documentId = obj?.documentId;
    this.AppointmentFileName = obj?.fileName;
    this.documentComment = obj?.comment;
    this.documentSource = obj?.source;
    this.documentSourceId = obj?.applicationId;
    this.GetImageToShow(obj?.fileType, obj?.documentUrl)
  }

  async downloadFile(filename: any, isZip: boolean) {
    const model = {
      isZip: isZip,
      fileName: []
    }
    if (isZip) {
      this.documentList.forEach(element => {
        model.fileName.push(element?.documentUrl);
      });
    }
    else {
      model.fileName.push(filename);
    }
    this.spinner.show();
    await this.documentUploadService.GetDemandDownloadFile(`${this.apiBaseUrl}/Download`, model).then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          const file = res.responseObject;
          const blob = Utility.base64toBlob(file.fileContents, file.contentType);
          saveAs(blob, isZip ? this.viewDemandDocument.demandName : file.fileDownloadName);
        }
      }).finally(() => {
        this.spinner.hide();
      })
  }

  ShowInNewTab() {
    window.open(this.imageToOpen, '_blank');
  }

}
